/**
 * Created by kz on 02.07.17.
 */
import axios from '../../axios'

export const getTender = (id) => {
  return axios.get('/tender/' + id)
}

export const getTenders = () => {
  return axios.get('/tender')
}

export const getLastTenders = () => {
  return axios.get('/tender/last')
}

export const getTenderStageParticipations = (tenderId, stageId) => {
  return axios.get('/tender/' + tenderId + '/stage/' + stageId + '/participations')
}

export const createTender = ({name, description, holderName}) => {
  return axios.post('/tender', {name, description, holderName})
}

export const describe = (id, {name, description, holderName}) => {
  return axios.post('/tender/' + id + '/describe', {name, description, holderName})
}

export const archive = (id) => {
  return axios.post('/tender/' + id + '/archive')
}

export const addStage = (tenderId, stage) => {
  return axios.post('/tender/' + tenderId + '/stage', stage)
}

export const renameStage = (tenderId, stageId, name) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/rename', {name})
}

export const removeStage = (tenderId, stageId) => {
  return axios.delete('/tender/' + tenderId + '/stage/' + stageId)
}

export const conditions = (tenderId, conditions) => {
  return axios.post('/tender/' + tenderId + '/conditions', conditions)
}

export const launchStage = (tenderId, stageId) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/launch')
}

export const suspendStage = (tenderId, stageId) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/suspend')
}

export const inviteToStage = (tenderId, stageId, invites) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/invite', {
    participants: invites
  })
}

export const loadLotsToStage = (tenderId, stageId, {lots, keys}) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/lots', {lots, keys})
}

export const stageQuestionnaire = (tenderId, stageId, questionnaire) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/questionnaire', questionnaire)
}

export const planStageDates = (tenderId, stageId, {scheduledLaunch, scheduledSuspend}) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/dates', {scheduledLaunch, scheduledSuspend})
}

export const report = (tenderId, stageId) => {
  return axios.post('/tender/' + tenderId + '/stage/' + stageId + '/report')
}

export const getLists = () => {
  return axios.get('/lists')
}

export const prepare = (id, data) => {
  return axios.post('/tender/' + id + '/prepare', data)
}

export const tenderParticipations = (id) => {
  return axios.get('/tender/' + id + '/participations')
}

export const tenderDates = (id, data) => {
  return axios.post('/tender/' + id + '/dates', data)
}

export const sendInvites = (id) => {
  return axios.post('/tender/' + id + '/invites')
}

export const sendWinnerEmail = (participationId) => {
  return axios.post('/tender/winner/' + participationId)
}



// WEBPACK FOOTER //
// ./src/api/production/tender/index.js